const StoreFrontAPI = {
    TOKEN: "419b0968ac2e6c9896f6df81a2c1a450",
    /**
     * Execution d'une requete graphql via StoreFront API
     * @param {*} variables 
     * @returns 
     */
    fetch: async (query, variables) => {
        const res = await fetch(`https://sayhar-2.myshopify.com/api/2026-04/graphql.json`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": StoreFrontAPI.TOKEN,
            },
            body: JSON.stringify({ query, variables }),
        });
        const json = await res.json();
        if (json.errors) {
            throw new Error(`GraphQL errors: ${JSON.stringify(json.errors)}`);
        }
        return json.data;
    }
};